export default __webpack_public_path__ + "static/media/take-selfie-example-2.7e8d5303.png";